import React, { useCallback } from 'react'
import { useParams, Redirect, useHistory } from 'react-router-dom'

import { useItem } from '../hooks'

import Button, { BUTTON_STYLES } from '../../common/components/Button'

const ItemDelete = ({ apiUrl, routeName, label }) => {
  const { id } = useParams() // returns string
  const history = useHistory()
  const [{ response: item, isLoading, error }, { remove }] = useItem(apiUrl, id)

  const onDelete = useCallback(() => {
    remove()
    history.push(`/admin/${routeName}/${id}`)
  }, [id, remove, history, routeName])

  if (isLoading) return <div>Loading...</div>
  if (error) return <div>{error}</div>
  if (item === null) return <Redirect to={`/admin/${routeName}`} />

  return (
    <div>
      <span>Do you really want to delete {label(item)}?</span>
      <Button onClick={onDelete} text="Yes" style={BUTTON_STYLES.DANGER} />
      <Button
        onClick={() => history.push(`/admin/${routeName}/${id}`)}
        text="Cancel"
      />
    </div>
  )
}

export default ItemDelete
